"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importItemsReducer = exports.searchItemsReducer = exports.updateItemsReducer = exports.createItemsReducer = exports.fetchItemsReducer = exports.clearItemsState = exports.importItemsSlice = exports.searchItemsSlice = exports.updateItemsSlice = exports.createItemsSlice = exports.fetchItemsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const itemsAction_1 = require("./itemsAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const searchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const importInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchItemsSlice = (0, toolkit_1.createSlice)({
    name: 'items/fetch',
    initialState: fetchInitialState,
    reducers: {
        clearItemsState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(itemsAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(itemsAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(itemsAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createItemsSlice = (0, toolkit_1.createSlice)({
    name: 'items/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(itemsAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(itemsAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(itemsAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateItemsSlice = (0, toolkit_1.createSlice)({
    name: 'items/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(itemsAction_1.update.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(itemsAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(itemsAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.searchItemsSlice = (0, toolkit_1.createSlice)({
    name: 'items/search',
    initialState: searchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(itemsAction_1.search.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(itemsAction_1.search.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(itemsAction_1.search.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.importItemsSlice = (0, toolkit_1.createSlice)({
    name: 'items/import',
    initialState: importInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(itemsAction_1.importItems.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(itemsAction_1.importItems.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(itemsAction_1.importItems.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.clearItemsState = exports.fetchItemsSlice.actions.clearItemsState;
exports.fetchItemsReducer = exports.fetchItemsSlice.reducer;
exports.createItemsReducer = exports.createItemsSlice.reducer;
exports.updateItemsReducer = exports.updateItemsSlice.reducer;
exports.searchItemsReducer = exports.searchItemsSlice.reducer;
exports.importItemsReducer = exports.importItemsSlice.reducer;
